var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.19453 6.86333C6.06995 6.98829 6 7.15755 6 7.334V9.05845C6 9.42669 6.29848 9.72509 6.66666 9.72509H8.39052C8.56733 9.72509 8.73691 9.65489 8.86193 9.52989L15.5266 2.8652C15.7877 2.60407 15.7868 2.18042 15.5246 1.9204L13.7827 0.193267C13.5218 -0.0654832 13.1006 -0.0642632 12.8412 0.195995L6.19453 6.86333Z",
    fill: "#006FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1H3.66667C2.19391 1 1 2.19391 1 3.66667V12.3333C1 13.8061 2.19391 15 3.66667 15H12.3333C13.8061 15 15 13.8061 15 12.3333V10",
    stroke: "#006FFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.229d83b79c0f150672ec3929ba06dcbd.svg";
export { ForwardRef as ReactComponent };